<template>
  <v-row class="align-center justify-center flex-col py-12">
    <p class="text-blue-300 font-bold uppercase mb-4">
      Acceso interno entrega de dispositivos
    </p>
    <v-col :style="{ 'max-width': '350px' }" class="bg-white shadow rounded">
      <v-form ref="form" @submit.prevent="handleLogin" class="p-6">
        <v-text-field
          :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
          :type="passwordVisible ? 'text' : 'password'"
          @click:append="passwordVisible = !passwordVisible"
          @input="error = ''"
          label="Contraseña"
          :error-messages="error"
          outlined
          required
          v-model="form.password"
        ></v-text-field>

        <v-autocomplete
          :items="centros"
          label="Centro"
          outlined
          required
          v-model="form.center"
        ></v-autocomplete>

        <div class="text-center">
          <v-btn
            :disabled="
              loading ||
              form.password.trim().length === 0 ||
              form.center === null
            "
            :loading="loading"
            color="primary"
            large
            raised
            type="submit"
          >
            Acceder</v-btn
          >
        </div>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import store from "@/store";

export default {
  name: "Login",

  data() {
    return {
      centros: [],
      error: "",
      form: {
        password: "",
        center: null,
      },
      passwordVisible: false,
      loading: false,
    };
  },

  created() {
    window.CmsApi.hook(this.$root.hookEndPoint, { action: "getCentros" }).then(
      (response) => {
        if (response.success) {
          this.centros = response.data.datos.registros.map((centro) => {
            return {
              text: centro.title,
              value: centro,
            };
          });
        }
      }
    );
  },

  methods: {
    handleLogin() {
      window.CmsApi.hook(this.$root.hookEndPoint, {
        action: "login",
        data: JSON.stringify({ password: this.form.password }),
      }).then((response) => {
        if (response.success) {
          window.CmsApi.hook(this.$root.hookEndPoint, {
            action: "getModelosRenove",
          }).then((response) => {
            if (response.success) {
              store.state.modelosRenove = response.data.datos.registros;
            }
          });

          store.setSchool(this.form.center);
          store.state.validPassword = true;

          this.$router.push({
            name: "Home",
          });
        } else {
          this.error = "Contraseña incorrecta.";
        }
      });
    },
  },
};
</script>
